var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3483FA",
  fillRule: "evenodd",
  d: "M14 8.75a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0m-1.428 4.946a6.25 6.25 0 1 1 .743-.677L17 16.293a.5.5 0 1 1-.665.747l-3.75-3.333z",
  clipRule: "evenodd"
})));
export default SvgSearchIcon;